import { render } from "./ConfirmPta.vue?vue&type=template&id=3da34a42&scoped=true&ts=true"
import script from "./ConfirmPta.vue?vue&type=script&lang=ts"
export * from "./ConfirmPta.vue?vue&type=script&lang=ts"

import "./ConfirmPta.vue?vue&type=style&index=0&id=3da34a42&scoped=true&lang=scss"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da34a42"]])

export default __exports__